<button
  (click)="exportDatas()"
  class="btn-icon btn-small download-btn"
  matTooltipPosition="above"
  matTooltip="Télécharger les données sélectionnées"
>
  <img alt="" src="../../../assets/img/download.svg" />
</button>
